<script>
import moment from "moment";
import { mapGetters } from "vuex";
import ComplianceForm from "./ComplianceForm";

export default {
  name: "UpdateActionForm",
  components: { ComplianceForm },
  data() {
    return {
      data: null,
      complinaces: [],
      complinaceItems: [],
    };
  },
  computed: {
    ...mapGetters("i18N", ["getLanguage"]),
    ...mapGetters("modal", ["getModalInfo"]),
    ...mapGetters("compliance", ["getComplianceUserDetails"]),
  },
  beforeMount() {
    console.log(
      "getComplianceUserDetails",
      this.getComplianceUserDetails,
      this.getModalInfo
    );

    // if (this.getModalInfo != "expected") {
    //   const convertComplinaces = JSON.parse(JSON.stringify(this.getModalInfo));
    //   this.complinaces =
    //     convertComplinaces.length > 0
    //       ? convertComplinaces.map((complinance) => {
    //           let pivot = complinance.pivot ? JSON.parse(complinance.pivot.metadata) : "";
    //           return {
    //             name: complinance.name,
    //             id: complinance.id,
    //             type: complinance.type,
    //             answer: complinance.form_metadata ? complinance.form_metadata : "",
    //             pivot: pivot,
    //           };
    //         })
    //       : [];
    // }
  },
  methods: {
    getDate(date) {
      if (this.getLanguage === "ar")
        return moment
          .utc(date)
          .tz(moment.tz.guess())
          .locale('en') // Ensures numbers remain in English
          .format("DD/MM/YYYY - h:mm") + 
          (moment.utc(date).tz(moment.tz.guess()).format("A") === "AM" ? " ص" : " م");

      return moment
      .utc(date)
      .tz(moment.tz.guess())
      .format("DD/MM/YYYY - h:mm A");
    },

    getDay(date) {
      return moment.utc(date).tz(moment.tz.guess()).format("DD/MM/YYYY");
    },
  },
};
</script>

<template>
  <div class="site-details-wrapper">
    <div class="modal-toptitle">
      <p class="modal-title">{{ $t('common.complianceDetails')}}</p>

      <svg
        class="close-btn-svg"
        @click="$bvModal.hide('dashboardCompliances')"
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11 0C4.91333 0 0 4.91333 0 11C0 17.0867 4.91333 22 11 22C17.0867 22 22 17.0867 22 11C22 4.91333 17.0867 0 11 0ZM16.5978 14.7156C17.1111 15.2289 17.1111 16.06 16.5978 16.5733C16.3289 16.8422 16.0111 16.9644 15.6689 16.9644C15.3267 16.9644 14.9844 16.8422 14.74 16.5733L11.0733 12.9067L7.38222 16.5733C7.11333 16.8422 6.79556 16.9644 6.45333 16.9644C6.11111 16.9644 5.76889 16.8422 5.52444 16.5733C5.01111 16.06 5.01111 15.2289 5.52444 14.7156L9.21556 11.0244L5.52444 7.35778C5.01111 6.84444 5.01111 6.01333 5.52444 5.5C6.03778 4.98667 6.86889 4.98667 7.38222 5.5L11.0733 9.19111L14.7644 5.5C15.2778 4.98667 16.1089 4.98667 16.6222 5.5C17.1356 6.01333 17.1356 6.84444 16.6222 7.35778L12.9311 11.0489L16.5978 14.7156Z"
          fill="#F46A6A"
        />
      </svg>
    </div>

    <template v-if="complinaces.length > 0">
      <div v-for="(el, i) in complinaces" :key="'el' + i">
        <ComplianceForm :element="el" :index="i" />
      </div>

      <div class="d-flex justify-content-end align-items-center">
        <button
          class="btn btn-primary px-3"
          @click="$bvModal.hide('dashboardCompliances')"
        >
          {{ $t('common.close') }}
        </button>
      </div>
    </template>

    <template
      v-if="
        getComplianceUserDetails.compliances &&
        getComplianceUserDetails.compliances.questionnaires
      "
    >
      <div class="grayagreement-con">
        <h2 class="agree-question">{{ $t('common.questionnaire') }}</h2>
      </div>
      <div
        class="questions-custom"
        v-for="(questions, type, i) in getComplianceUserDetails.compliances
          .questionnaires"
        :key="'q' + i"
      >
        <h4 class="side-question">{{ type }}</h4>
        <div
          class="questions2-custom"
          v-for="(compliances, question, index) in questions"
          :key="'c' + index"
        >
          <p class="txt-body">{{ index + 1 + "-" }} {{ question }}</p>
          <div
            class="alltxt-customization"
            v-for="(compliance, index1) in compliances"
            :key="'compliance' + index1"
          >
            <p
              :class="{
                'text-green': JSON.parse(compliance.metadata.answer.desired),
                'text-red': !JSON.parse(compliance.metadata.answer.desired),
              }"
            >
              {{ compliance.metadata.answer.text }}
            </p>
            <div class="graytxt-con">
              <span class="first-gray">{{
                getDate(compliance.updated_at)
              }}</span>
              <span class="second-gray">
                ({{
                  $t(`common.${compliance.metadata.actionBy.toLowerCase()}`) +
                  (compliance.metadata.actionBy == "Admin"
                    ? " - " + compliance.full_name_action_by
                    : "")
                }})</span
              >
            </div>
          </div>

          <!-- Notes -->
          <div
            class="notes-graycon"
            v-if="
              compliances.length > 0 &&
              compliances.find((item) => item.metadata.notes) &&
              index == Object.keys(questions).length - 1
            "
          >
            <h4 class="notes-header">{{ $t('common.notes.notes')}}</h4>
            <div
              v-for="(compliance, index2) in compliances"
              :key="'notes' + index2"
            >
              <div v-if="compliance.metadata.notes">
                <p class="notes-txt">{{ compliance.metadata.notes }}</p>
                <span class="notes-date">{{
                  getDate(compliance.updated_at)
                }}</span>
                <span class="notes-bywhom"
                  >({{
                    $t(`common.${compliance.metadata.actionBy.toLowerCase()}`) +
                    (compliance.metadata.actionBy == "Admin"
                      ? " - " + compliance.full_name_action_by
                      : "")
                  }})</span
                >
              </div>

              <hr
                class="addcustom-line"
                v-if="
                  compliances.length > 1 &&
                  index2 != compliances.length - 1 &&
                  compliances[index2 + 1].metadata.notes
                "
              />
            </div>
          </div>
        </div>
      </div>
    </template>

    <template
      v-if="
        getComplianceUserDetails.compliances &&
        getComplianceUserDetails.compliances.agreements
      "
    >
      <div class="grayagreement-con">
        <h2 class="agree-question">{{ $t('common.agreement')}}</h2>
      </div>
      <div
        class="questions-custom"
        v-for="(questions, type, i) in getComplianceUserDetails.compliances
          .agreements"
        :key="'agr' + i"
      >
        <h4 class="side-question">{{ type }}</h4>
        <div
          class="questions2-custom"
          v-for="(compliances, question, index) in questions"
          :key="'qu' + index"
        >
          <p class="txt-body">
            {{ question }}
          </p>
          <div
            class="alltxt-customization"
            v-for="(compliance, index1) in compliances"
            :key="'index1' + index1"
          >
            <p
              :class="{
                'text-green': JSON.parse(compliance.metadata.answer.desired),
                'text-red': !JSON.parse(compliance.metadata.answer.desired),
              }"
            >
              {{ compliance.metadata.answer.text }}
            </p>
            <div class="graytxt-con">
              <span class="first-gray">{{
                getDate(compliance.updated_at)
              }}</span>
              <span class="second-gray">
                ({{
                  $t(`common.${compliance.metadata.actionBy.toLowerCase()}`) +
                  (compliance.metadata.actionBy == "Admin"
                    ? " - " + compliance.full_name_action_by
                    : "")
                }})</span
              >
            </div>
          </div>

          <!-- Notes -->
          <div
            class="notes-graycon"
            v-if="
              compliances.length > 0 &&
              compliances.find((item) => item.metadata.notes)
            "
          >
            <h4 class="notes-header">{{ $t('common.notes.notes')}}</h4>
            <div
              v-for="(compliance, index2) in compliances"
              :key="'index2' + index2"
            >
              <div v-if="compliance.metadata.notes">
                <p class="notes-txt">{{ compliance.metadata.notes }}</p>
                <span class="notes-date">{{
                  getDate(compliance.updated_at)
                }}</span>
                <span class="notes-bywhom"
                  >({{
                    $t(`common.${compliance.metadata.actionBy.toLowerCase()}`) +
                    " - " +
                    (compliance.metadata.actionBy == "Admin"
                      ? compliance.full_name_action_by
                      : "")
                  }})</span
                >
              </div>

              <hr
                class="addcustom-line"
                v-if="
                  compliances.length > 1 &&
                  index2 != compliances.length - 1 &&
                  compliances[index2 + 1].metadata.notes
                "
              />
            </div>
          </div>
        </div>
      </div>
    </template>

    <template v-if="getComplianceUserDetails.documents">
      <div class="grayagreement-con">
        <h2 class="agree-question">{{ $t('common.documentVaccinePcr') }}</h2>
      </div>
      <div
        v-for="(document, i) in getComplianceUserDetails.documents"
        :key="'doc' + i"
      >
        <h2 class="vaccine-data">
          {{ document.name }}
        </h2>

        <div
          class="gray-Pcrcontainer"
          v-if="document.user_documents_type != 'covid_vaccine'"
        >
          <div class="sub-graypcr-container">
            <div
              class="col-lg-6"
              :class="{
                'vp-border-right-grey-4-1': JSON.parse(
                  document.user_documents_metadata
                ).fileAttach,
              }"
            >
              <div class="pcr-result">{{ $t('signInOut.pcrResult')}}</div>
              <div class="pcr-result-subtitle">
                {{
                  JSON.parse(document.user_documents_metadata).certificateModel
                    .tests[0].testResult == "Detected"
                    ? "Positive"
                    : "Negative"
                }}
              </div>
              <div class="pcr-date">{{$t('common.pcrDate')}}</div>
              <div class="pcr-date-subtitle">
                {{
                  getDay(
                    JSON.parse(document.user_documents_metadata)
                      .certificateModel.tests[0].dateTimeOfTestResult
                  )
                }}
              </div>
            </div>
            <div
              v-if="JSON.parse(document.user_documents_metadata).fileAttach"
              class="col-lg-6 image-size"
              style="
                display: flex;
                justify-content: flex-end;
                padding-inline-end: 0px;
              "
            >
              <div
                v-viewer
                class="right-pcr-image"
                style="width: 127px; height: 97px"
              >
                <img
                  style="cursor: pointer; width: 100%; height: 100%"
                  class="img-bg"
                  :src="JSON.parse(document.user_documents_metadata).fileAttach"
                />
              </div>
            </div>
          </div>

          <div
            class="notes-graycon"
            v-if="document.metadata && document.metadata.notes"
          >
            <hr class="addcustom-line" />
            <h4 class="vaccine-notes-header">{{ $t('common.notes.notes') }}</h4>
            <p class="vaccine-notes-txt">
              {{ document.metadata.notes }}
            </p>
          </div>
        </div>

        <div
          class="gray-vaccinecontainer"
          v-if="document.user_documents_type == 'covid_vaccine'"
        >
          <div class="sub-graycontainer">
            <div class="row-one vaccine-name">
              <p class="vaccine-protocol">{{ $t('common.doc.vaccineProtocol') }}</p>
              <p class="vaccine-protocol-subtitle">
                {{ JSON.parse(document.user_documents_metadata).protocol }}
              </p>
              <hr class="addcustom-line" style="margin-bottom: 0px" />
            </div>
            <div
              class="columns-container d-flex justify-content-center"
              :class="{
                'justify-content-between': JSON.parse(
                  document.user_documents_metadata
                ).fileAttach,
              }"
            >
              <div class="vp-border-right-grey-4-1">
                <div class="Vaccine-Name">{{ $t('common.doc.vaccineName')}}</div>
                <div class="Vaccine-result">
                  {{
                    JSON.parse(document.user_documents_metadata)
                      .certificateModel.vaccinations[0].vaccine
                  }}
                </div>
                <div class="Vaccine-Date">{{$t('common.vaccineDate')}}</div>
                <div class="Vaccine-Date-result">
                  {{
                    JSON.parse(document.user_documents_metadata)
                      .certificateModel.vaccinations[0].dateOfVaccination
                  }}
                </div>
              </div>

              <div
                :class="{
                  'vp-ml-25': !JSON.parse(document.user_documents_metadata)
                    .fileAttach,
                  'vp-border-right-grey-4-1': JSON.parse(
                    document.user_documents_metadata
                  ).fileAttach,
                }"
              >
                <template
                  v-if="
                    JSON.parse(document.user_documents_metadata)
                      .certificateModel.vaccinations[0].batchNumber
                  "
                >
                  <div class="Batch-Number">{{ $t('common.doc.batchNumber')}}</div>
                  <div class="Batch-Number-result">
                    {{
                      JSON.parse(document.user_documents_metadata)
                        .certificateModel.vaccinations[0].batchNumber
                    }}
                  </div>
                </template>
                <div class="Vaccine-Expiry">{{ $t('common.Vaccine Expiry') }}</div>
                <div class="Vaccine-Expiry-result">
                  {{
                    getDay(
                      JSON.parse(document.user_documents_metadata)
                        .greenCertificatData.expirationTime
                    )
                  }}
                </div>
              </div>

              <div
                v-if="JSON.parse(document.user_documents_metadata).fileAttach"
                style="
                  display: flex;
                  justify-content: flex-end;
                  padding-inline-end: 0px;
                "
              >
                <div
                  v-viewer
                  class="images dash-img clearfix"
                  style="width: 127px; height: 97px"
                >
                  <img
                    style="
                      cursor: pointer;
                      width: 100%;
                      height: 100% !important;
                    "
                    class="img-bg"
                    :src="
                      JSON.parse(document.user_documents_metadata).fileAttach
                    "
                  />
                </div>
              </div>
            </div>
          </div>

          <div
            class="notes-graycon"
            v-if="document.metadata && document.metadata.notes"
          >
            <hr class="addcustom-line" />
            <h4 class="vaccine-notes-header">{{ $t('common.notes.notes')}}</h4>
            <p class="vaccine-notes-txt">
              {{ document.metadata.notes }}
            </p>
          </div>
        </div>

        <span class="seprated-vaccinetime"
          >{{ getDate(document.updated_at) }}
        </span>
        <span class="seprated-vaccineby"
          >({{ document.metadata.actionBy ? document.metadata.actionBy : "User"
          }}{{
            document.metadata.actionBy
              ? " - " + document.full_name_action_by
              : ""
          }})</span
        >
      </div>
    </template>
  </div>
</template>
<style lang="scss">
div#dashboardCompliances {
  div#dashboardCompliances___BV_modal_content_ {
    div#dashboardCompliances___BV_modal_body_ {
      padding: 0px !important;
      .close-btn-svg{
        margin-inline-end: 33px;
        float: inline-end; 
        margin-top: -30px;
      }
      .close-btn-svg:lang(ar){
        margin-inline-start: 33px;
        float: unset;   
      }
      p.modal-title {
        font-weight: 700;
        font-size: 17px;
        line-height: 20px;
        text-align: center;

        color: #000000;
      }

      .modal-toptitle {
        width: 100%;

        margin-top: 33px;
        margin-bottom: 40px;
      }
      .modal-closeing {
        margin-inline-end: 33px;
        cursor: pointer;
      }
      .grayagreement-con {
        margin-inline-end: 23px;
        margin-inline-start: 23px;
        background: #f7f7f7;
        height: 28px;
        display: flex;
        h2.agree-question {
          font-weight: 400;
          font-size: 14px;
          line-height: 17px;
          color: #939393;
          margin-top: 5px;
          margin-inline-end: auto;
          margin-bottom: 5px;
          margin-inline-start: 17px;
          margin-top: 5px;
          margin-inline-end: auto;
          margin-bottom: 5px;
          margin-inline-start: 17px;
        }
      }
      //////////////////////

      .questions-custom {
        margin-top: 0px;
        margin-inline-end: 6px;
        margin-bottom: 0px;
        margin-inline-start: 23px;
        h4.side-question {
          font-weight: 400;
          font-size: 14px;
          line-height: 17px;
          color: #939393;
          margin-top: 10px;
          margin-inline-start: 17px;
          margin-bottom: 13px;
        }
        .questions2-custom {
          p.txt-body {
            font-weight: 400;
            font-size: 14px;
            line-height: 17px;
            color: #495057;
            margin-bottom: 20px;
            margin-inline-start: 17px;
            word-wrap: break-word !important;
          }
        }

        .alltxt-customization {
          margin-inline-start: 17px;

          p.text-green {
            font-weight: 500 !important;
            font-size: 14px !important;
            line-height: 17px !important;
            color: #34c38f !important;
            margin-bottom: 13px !important;
          }
          p.text-red {
            font-weight: 500 !important;
            font-size: 14px !important;
            line-height: 17px !important;
            margin-bottom: 13px !important;
            color: #f46a6a !important;
          }
          .graytxt-con {
            margin-bottom: 21px;
            span.first-gray {
              font-weight: 400;
              font-size: 14px;
              line-height: 17px;
              color: #c7c7c7;
              margin-inline-end: 15px;
            }
            span.second-gray {
              font-weight: 400;
              font-size: 14px;
              line-height: 17px;
              color: #c7c7c7;
              // margin-inline-end: 15px;
            }
          }
        }
      }
      h2.vaccine-data {
        font-weight: 400;
        font-size: 14px;
        line-height: 17px;
        margin-top: 10px;
        margin-bottom: 9px;
        margin-inline-start: 35px;
        color: #939393;
      }
      .gray-vaccinecontainer {
        background: #f7f7f7;
        border-radius: 10px;
        margin-inline-end: 23px;
        margin-inline-start: 23px;
        margin-bottom: 8px;
        .sub-graycontainer {
          margin: 0px 24px 0px 24px;
        }
      }
      .pcr-block {
        width: 206px;
      }
      span.seprated-vaccinetime {
        margin-inline-start: 47px;
        padding-bottom: 35px;

        font-weight: 400;
        font-size: 14px;
        line-height: 17px;
        color: #c7c7c7;
        margin-inline-end: 15px;
      }
      span.seprated-vaccineby {
        font-weight: 700;
        font-size: 14px;
        line-height: 17px;
        color: #c7c7c7;
      }
      .notes-graycon {
        background: #f7f7f7;
        border-radius: 10px;
        margin-bottom: 21px;
        padding-bottom: 21px;
        width: 437px;
        .addcustom-line {
          margin: 21px 23px 20px 23px;
          opacity: 0.08;
          background: #000000;
          //  height: 1px;
        }
        h4.notes-header {
          font-weight: 400;
          font-size: 14px;
          line-height: 17px;
          color: #939393;
          margin-top: 22px;
          margin-inline-end: auto;
          margin-bottom: 16px;
          margin-inline-start: 23px;
          padding-top: 22px;
        }
        p.notes-txt {
          font-weight: 400;
          font-size: 14px;
          word-break: break-word;
          line-height: 19px;
          color: #495057;
          margin-inline-start: 23px;
          margin-inline-end: 23px;
          margin-bottom: 13px;
        }
        span.notes-date {
          font-weight: 400;
          font-size: 14px;
          line-height: 17px;
          color: #c7c7c7;
          margin-top: 0px;
          margin-inline-end: 15px;
          margin-bottom: 0px;
          margin-inline-start: 23px;
          padding-bottom: 21px !important;
        }
        span.notes-date {
          font-weight: 400;
          font-size: 14px;
          line-height: 17px;
          color: #c7c7c7;
          margin-top: 0px;
          margin-inline-end: 15px;
          margin-bottom: 0px;
          margin-inline-start: 23px;
          padding-bottom: 21px !important;
        }
        span.notes-bywhom {
          font-weight: 700;
          font-size: 14px;
          line-height: 17px;
          color: #c7c7c7;
        }
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.gray-Pcrcontainer {
  background: #f7f7f7;
  border-radius: 10px;
  margin: auto;
  width: 437px;
  margin-bottom: 20px;
  .sub-graypcr-container {
    padding: 18px 24px;
    display: flex;
    .right-pcr-image {
      display: flex;
      justify-content: end;
    }
    .pcr-result,
    .pcr-date {
      font-weight: 400;
      font-size: 14px;
      line-height: 17px;
      color: #c7c7c7;
      padding-bottom: 3px;
    }
    .pcr-result-subtitle,
    .pcr-date-subtitle {
      font-weight: 400;
      font-size: 14px;
      line-height: 17px;
      color: #495057;
      word-break: break-word;
    }
    .pcr-result-subtitle {
      padding-bottom: 16px;
    }
  }
}
h4.vaccine-notes-header {
  margin-inline-start: 24px;
  margin-bottom: 10px;

  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  color: #939393;
}
p.vaccine-notes-txt {
  font-weight: 400;
  font-size: 14px;
  line-height: 19px;
  color: #495057;
  margin-inline-start: 24px;
  margin-bottom: 0px;
}
.columns-container {
  padding-top: 18px;
  padding-bottom: 16px;
}
p.vaccine-protocol {
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  padding-top: 15px;
  padding-bottom: 3px;
  color: #c7c7c7;
}
p.vaccine-protocol-subtitle {
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  color: #495057;
}
.col-lg-4 {
  padding-inline-start: 0px;
}
.col-lg-6 {
  padding-inline-start: 0px;
}
.Vaccine-Name,
.Batch-Number,
.Vaccine-Expiry,
.Vaccine-Date {
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  color: #c7c7c7;
  padding-bottom: 3px;
  padding-inline-end: 20px;
}
.Vaccine-result,
.Batch-Number-result,
.Vaccine-Expiry-result,
.Vaccine-Date-result {
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  color: #495057;
  word-break: break-word;
  padding-inline-end: 20px;
}
.Vaccine-result,
.Batch-Number-result {
  padding-bottom: 16px;
}
.Batch-Number-result {
  padding-bottom: 16px;
}
</style>
